const errorKeys: Record<string, string> = {
  CAPTURE_AI_CONFIGURATION: 'configurationError',
  CAPTURE_AI_AUTH: 'configurationError',
  CAPTURE_AI_REQUEST: 'modelError',
  CAPTURE_AI_RATE_LIMIT: 'rateLimitError',
  CAPTURE_AI_TIMEOUT: 'timeoutError',
  CAPTURE_AI_RESPONSE: 'responseError',
  CAPTURE_AI_TRUNCATED: 'truncatedError',
  CAPTURE_AI_REFUSAL: 'refusalError',
  CAPTURE_AI_UNAVAILABLE: 'providerError',
};

/** The HTTP exception filter wraps the backend response under `message`. */
export function captureAnalysisErrorKey(error: unknown): string {
  const response = (
    error as { response?: { status?: number; data?: { code?: string; message?: { code?: string } } }; code?: string }
  )?.response;
  const code = response?.data?.code ?? response?.data?.message?.code;
  if (typeof code === 'string' && Object.prototype.hasOwnProperty.call(errorKeys, code))
    return `copilot.capture.${errorKeys[code]}`;
  if (response?.status === 409) return 'copilot.capture.analysisBusy';
  if (response?.status === 401 || response?.status === 403) return 'copilot.capture.accessError';
  if (response?.status === 413) return 'copilot.capture.sizeError';
  if (response?.status === 503) return 'copilot.capture.providerError';
  if ((error as { code?: string })?.code === 'ECONNABORTED') return 'copilot.capture.timeoutError';
  return 'copilot.capture.analyzeError';
}
